import React from 'react';
import { BrowserRouter,Switch, Route } from 'react-router-dom'
// import { connect } from 'react-redux';
import './App.css';

// import Header from './components/header/header.component';
// import Footer from './components/footer/footer.component';
// import HomePage from './pages/homepage/homepage.component';
import Questionnaire from './pages/questionnaire/questionnaire.component'

function App() {

  return (
      <div>
        
        <BrowserRouter>
        {/* <Header /> */}
        <Switch> 
          
          <Route exact path='/' component={Questionnaire}></Route>

        </Switch>
        <br/><br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/><br/> <br/>
        {/* <Footer /> */}
        </BrowserRouter>
      </div>
  )
}

export default App;
